module.exports = __webpack_public_path__ + "static/media/MovingApp_android_1.9409506a.jpg";